module.exports = __webpack_public_path__ + "assets/img/news (18).991c4725.png";